<template>
  <el-table
    :data="warehousesData"
    class="table-content rounded-xl w-full"
    header-cell-class-name="custom-table__header-cell"
    cell-class-name="custom-table__cell"
    border
    :empty-text="$t('empty')"
    ref="tableRef"
    @sort-change="handleSortChange"
  >
    <el-table-column
      v-for="col in tableColumns"
      :key="col.prop"
      :prop="col.prop"
      :label="col.label"
      :min-width="20"
      :width="col.width"
      :sortable="col.sortable"
    >
      <template v-slot="scope">
        {{ scope.row[col.prop] }}
      </template>
    </el-table-column>
  </el-table>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import { IWarehouse } from '@/utils/types/model/warehouse'

interface ITableColumn {
  prop: string
  label: string
  sortable?: boolean | string
  width?: number
}

@Options({
  name: 'WarehouseList',
  emits: ['sort-change'],
})
export default class WarehouseList extends Vue {
  @Prop({ type: Array, default: () => [] }) warehousesData!: IWarehouse[]

  get tableColumns(): ITableColumn[] {
    return [
      { prop: 'warehouseCode', label: this.$t('warehouses.warehouse_code'), sortable: 'custom' },
      { prop: 'name1', label: this.$t('warehouses.warehouse_name'), sortable: 'custom' },
      { prop: 'address1', label: this.$t('warehouses.address') },
      { prop: 'postalCode', label: this.$t('warehouses.postal_code') },
      { prop: 'phoneNumber', label: this.$t('warehouses.phone_number') },
      { prop: 'companyCode', label: this.$t('warehouses.company_code'), width: 150 },
    ]
  }

  handleSortChange(data: { prop: string; order: string | null }) {
    this.$emit('sort-change', data)
  }
}
</script>
